class SoundCatcherTheme {
  constructor() {
    this.drawer = document.querySelector('[data-cart-drawer]');
    this.overlay = document.querySelector('[data-cart-overlay]');
    this.status = document.getElementById('CartStatus');
    this.bindNavigation();
    this.bindCart();
    this.bindQuantity();
    this.bindReveals();
    this.refreshCart();
  }

  bindNavigation() {
    const toggle = document.querySelector('[data-menu-toggle]');
    const nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  bindCart() {
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-open]');
      const closer = event.target.closest('[data-cart-close]');
      if (opener) { event.preventDefault(); this.openCart(); }
      if (closer) { event.preventDefault(); this.closeCart(); }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('.js-product-form');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Adding…'; }
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error((await response.json()).description || 'Unable to add item');
        await this.refreshCart();
        this.openCart();
        this.announce('Item added to cart');
      } catch (error) {
        this.announce(error.message);
        window.alert(error.message);
      } finally {
        if (button) { button.disabled = false; button.textContent = button.dataset.label || 'Add To Cart'; }
      }
    });
  }

  bindQuantity() {
    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quantity-change]');
      if (!button) return;
      const input = document.getElementById(button.dataset.input);
      if (!input) return;
      const delta = Number(button.dataset.quantityChange);
      input.value = Math.max(1, Number(input.value || 1) + delta);
    });
  }

  async refreshCart() {
    if (!this.drawer) return;
    try {
      const cart = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { 'Accept': 'application/json' } }).then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      const items = this.drawer.querySelector('[data-cart-items]');
      const total = this.drawer.querySelector('[data-cart-total]');
      if (total) total.textContent = this.formatMoney(cart.total_price);
      if (!items) return;
      if (!cart.items.length) {
        items.innerHTML = '<p class="text-muted">Your cart is empty.</p>';
        return;
      }
      items.innerHTML = cart.items.map(item => `
        <div class="drawer-item">
          ${item.image ? `<img src="${item.image}" alt="${this.escape(item.product_title)}" width="144" height="144">` : '<div></div>'}
          <div><h3>${this.escape(item.product_title)}</h3>${item.variant_title ? `<p>${this.escape(item.variant_title)}</p>` : ''}<p>Qty ${item.quantity}</p></div>
          <strong>${this.formatMoney(item.final_line_price)}</strong>
        </div>`).join('');
    } catch (error) {
      console.warn('[SoundCatcher] Cart refresh failed', error);
    }
  }

  openCart() {
    if (!this.drawer || !this.overlay) return;
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    this.drawer.querySelector('[data-cart-close]')?.focus();
  }

  closeCart() {
    if (!this.drawer || !this.overlay) return;
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
  }

  bindReveals() {
    const elements = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { elements.forEach(el => el.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -60px', threshold: .08 });
    elements.forEach(el => observer.observe(el));
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  }

  escape(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  announce(message) { if (this.status) this.status.textContent = message; }
}

document.addEventListener('DOMContentLoaded', () => new SoundCatcherTheme());
